import createReducer from 'arts/config/create_reducer';
import Constants from '../config/const';

const getDefaultState = () => ({
  sourceId: null,
  loading: false,
  works: [],
  original: null
});

const moreLikeThis = createReducer(getDefaultState(), {
  [Constants.moreLikeThis.set]: (state, { sourceId, index, original }) => ({
    ...state,
    loading: false,
    works: [],
    sourceId,
    index,
    original
  }),
  [Constants.moreLikeThis.reset]: (state) => ({
    ...state,
    works: [],
    sourceId: null,
    index: 0,
    original: null
  }),
  [Constants.moreLikeThis.loading]: (state) => ({
    ...state,
    loading: true
  }),
  [Constants.moreLikeThis.loaded]: (state, { works }) => ({
    ...state,
    works,
    loading: false
  })
});

export default moreLikeThis;
